// src/components/InitialView.js
import React, { memo } from 'react';
import { Button } from '@/components/ui/button';
import VERSIONS from '@/assets/js/versions';

const APP = VERSIONS[process.env.REACT_APP_VERSION];

export const InitialView = memo(({ handleActionClick }) => {
  const brandName = APP.brand;
  const brandLogoUrl = APP.url;

  return (
    <div className="min-h-full flex flex-col items-center justify-center p-4 relative z-10">
      <div className="home-ai-fade-in-up mb-12 text-center">
        {/* Conditionally render the logo if the URL exists */}
        {brandLogoUrl && (
          <img
            src={brandLogoUrl}
            alt={`${brandName} Logo`}
            className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 rounded-full object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
            }}
          />
        )}
        <h1 className="text-foreground/70 text-4xl md:text-6xl font-bold mb-2 py-1">{brandName} AI</h1>
        <p className="text-muted-secondary/70 text-lg md:text-xl font-light">Your intelligent learning companion</p>
      </div>
      {/* <div className="home-ai-fade-in-up-delayed-2 flex gap-4 md:gap-6 flex-wrap justify-center">
        <Button
          disabled
          onClick={() => handleActionClick("I'd like to create a new course")}
          className="home-ai-action-btn px-6 py-3 text-white font-medium rounded-2xl"
          variant="ghost">
          Create Course
        </Button>
        <Button
          disabled
          onClick={() => handleActionClick('I want to create a quiz')}
          className="home-ai-action-btn px-6 py-3 text-white font-medium rounded-2xl"
          variant="ghost">
          Create Quiz
        </Button>
        <Button
          disabled
          onClick={() => handleActionClick('Help me create flashcards')}
          className="home-ai-action-btn px-6 py-3 text-white font-medium rounded-2xl"
          variant="ghost">
          Create Flashcards
        </Button>
      </div> */}
    </div>
  );
});
